import axios from 'axios';

// 1. Create a custom Axios instance.
const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASEURL,
  // headers: {
  //   'Content-Type': 'application/json',
  // },
});

// 2. Add a request interceptor to handle dynamic token assignment.
// We will check for the custom 'role' property on the config object.
api.interceptors.request.use(
  (config) => {

    if (config.role) {
      const role = config.role; // Get the custom 'role' property
      let token = null;

      if (role === 'company') {
        token = localStorage.getItem('companyToken');
      } else if (role === 'contractor') {
        token = localStorage.getItem('contractorToken');
      }

      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;